export default __webpack_public_path__ + "static/media/ri_shopping-cart-line.d88387a0.svg";